<template>
	<div :class="['summary__message', $attrs.class]" :style="$attrs.style">
		<p v-if="region === 'global'" class="summary__message__v4">
			<i18n class="attention" :path="getLicenseText('attention')" tag="p"></i18n>
			<i18n class="summary__message__terms_link license-text" :path="getLicenseText('notice')" tag="p">
				<template v-slot:highlight>
					<span v-t="getLicenseText('highlight')" class="highlight"></span>
				</template>
				<template v-slot:termsLink>
					<a
						v-t="getLicenseText('terms-link')"
						:href="digitalLicenseTerms"
						target="_blank"
						@click="handleTermClick"
					></a>
				</template>
			</i18n>
		</p>
		<p v-if="!isIngamePurchase && region === 'global'" class="summary__message__v4">
			{{ $t('checkout.v4-attention') }}
		</p>
		<p v-if="!isIngamePurchase && region === 'sea'" class="summary__message__v4">
			<i18n class="attention" path="checkout.digital-license-summary-attention" tag="p"></i18n>
			{{ $t('checkout.sea-attention') }}
		</p>
		<i18n class="summary__message__support license-text" path="checkout.need-help" tag="p">
			<template v-slot:supportLink>
				<a
					v-t="'checkout.support-link-text'"
					:href="supportLink"
					target="_blank"
					@click="handleSupportClick"
				></a>
			</template>
		</i18n>
	</div>
</template>

<script>
import links from '@/config/links';

export default {
	name: 'License',
	props: {},
	computed: {
		isIngamePurchase() {
			return this.$store.state.appType === 'game';
		},
		isMapleStoryWorld() {
			const serviceCode = this.$store.state.purchaseSummaryData.serviceCode;
			const MAPLE_STORY_WORLDS_SERVICE_CODES = ['S59797', 'S59796', 'S59794', 'S90000'];
			return MAPLE_STORY_WORLDS_SERVICE_CODES.includes(serviceCode);
		},
		digitalLicenseTerms() {
			return links[this.region].digitalLicenseTerms(this.$i18n.locale);
		},
		supportLink() {
			return links[this.region].supportLink;
		},
	},
	methods: {
		handleTermClick(e) {
			e.preventDefault();
			this.$emit('termClick');
			window.open(this.digitalLicenseTerms, '_blank');
		},
		handleSupportClick(e) {
			e.preventDefault();
			this.$emit('supportClick');
			window.open(this.supportLink, '_blank');
		},
		getLicenseText(type) {
			// type : 'notice', 'terms-link', 'attention', 'highlight',
			if (this.isIngamePurchase) {
				if (this.isMapleStoryWorld) {
					return `checkout.msw-direct-payment-digital-license-summary-${type}`;
				}

				return `checkout.direct-payment-digital-license-summary-${type}`;
			}

			return `checkout.digital-license-summary-${type}`;
		},
	},
};
</script>
<style lang="less" scoped>
.summary {
	&__message {
		text-align: left;
		p {
			margin: 0;
		}
		.highlight {
			color: #e63f57;
		}
		.attention {
			align-self: stretch;
			color: #fff;
			font-size: 14px;
			font-style: normal;
			font-weight: 700;
			line-height: normal;
			opacity: 0.8;
			margin-bottom: 10px;
		}
		.summary__message__v4 {
			margin-bottom: 10px;
			color: rgba(255, 255, 255, 0.5);
			font-size: 14px;
			font-style: normal;
			font-weight: 400;
			line-height: normal;
		}
		&__support {
			margin-bottom: 3px;
			a {
				text-transform: capitalize;
			}
		}
		p {
			line-height: 1.3;
		}
		a {
			color: inherit;
			text-decoration: underline;
			text-underline-position: under;
			&:hover {
				color: #fff;
			}
		}
	}
}
</style>
